import _ from 'lodash';

export default class FilterBetStatusPickerComponentAction {

    static checkSelectedAll(allDefinedBets, selectedBets, isSelectedAllDefinedBets) {
        return (isSelectedAllDefinedBets && _.isEmpty(selectedBets)) 
            || _.isEmpty(allDefinedBets) 
            || (!_.isEmpty(allDefinedBets) && _.isEmpty(_.difference(allDefinedBets, selectedBets)));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/AccountComponent/BettingHistoryComponent/FilterBetStatusPickerComponent/FilterBetStatusPickerComponentAction.js